<div class="ft-menu-object">
    <div class="ft-modal-dialog modal-notify modal-info">
            
            <div class="menu-object ft-modal-header">
                @if (data.title) {
                <h2 class="heading" mat-dialog-title>{{ data.title }}</h2>
                }
            </div>
            <mat-dialog-content class="mat-typography">
                <div class="ft-menu-content">
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput placeholder="Name" id="name-tf" type="text" name="name" [(ngModel)]="data.name" />
                    </mat-form-field>
                    
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input
                            matInput
                            placeholder="Description"
                            id="des-tf"
                            type="text"
                            name="description"
                            [(ngModel)]="data.description"
                        />
                    </mat-form-field>
                    
                    <div class="ft-checkbox-container">
                        <mat-checkbox id="isFtApp-tf" color="primary" name="isFieldtecApp" [(ngModel)]="data.isFieldtecApp">
                            Is Application link?
                        </mat-checkbox>
                    </div>
                    
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput placeholder="Address" id="addr-tf" type="text" name="address" [(ngModel)]="data.address" />
                    </mat-form-field>
                    
                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <input matInput placeholder="Icon" id="icon-tf" type="text" name="icon" [(ngModel)]="data.icon" />
                    </mat-form-field>

                    <mat-form-field [subscriptSizing]="'dynamic'">
                        <mat-label>Target</mat-label>
                        <mat-select [(ngModel)]="data.target">
                            <mat-option value="_self">Current Window</mat-option>
                            <mat-option value="_blank">New Tab</mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>
                
            </mat-dialog-content>
            
            <mat-dialog-actions class="menu-object ft-modal-footer justify-content-center" align="center">
            
              @if (data.confirmButton) {
              <button type="button" mat-button mat-raised-button color="warn" mat-dialog-close cdkFocusInitial class="ft-dialog-ok">OK</button>
              }
              @if (data.succFunc) {
              <button type="button" mat-button (click)="ok()" color="primary" mat-raised-button cdkFocusInitial class="ft-dialog-ok">OK</button>
              }
              @if (data.errorFunc) {
              <button type="button" mat-button (click)="cancel()" mat-raised-button class="ft-dialog-cancel">Cancel</button>
              }
              @if (data.discardFunc) {
              <button type="button" mat-button (click)="discard()" color="warn" mat-raised-button class="ft-dialog-discard">Discard</button>
              }
            
            </mat-dialog-actions>

    </div>
</div>
